import React from "react";
import {Card, Container} from "react-bootstrap";
import {dealstages} from "./CONSTANTS";


export const GuideText = ({dealstage, email}) => {
    const declareText = () => {
        switch (dealstage) {
            case dealstages.INKOMMENLEAD:
                return "Klicka nu på Slutföra offerten, bifoga fil gör du i nästa steg";
            case dealstages.OFFERTSKAPAD:
                return "Bifoga nu filen"
            case dealstages.OFFERTSKICKAD:
                return `Bra, nu är offerten skickad till ${email}`
            case dealstages.OFFERTSEDD:
                return `${email} har öppnat offerten`
            case dealstages.OFFERTGODKAND:
                return `${email} har godkänt offerten`
            case dealstages.OFFERTNEKAD:
                return `${email} har nekat offerten`
        }
    }

    return (
        <Container>
            <Card>
                <Card.Header>
                    {declareText()}

                </Card.Header>
                <Card.Body>
                    Steg 1: Klicka på "Slutföra offerten", bifoga fil gör du i nästa steg
                    <hr/>
                    Steg 2: Bifoga fil
                    <hr/>
                    Steg 3: Klicka på "skicka till {email}
                    <hr/>
                    Steg 4: Invänta svar från kund
                </Card.Body>
            </Card>
        </Container>
    )
}
